<mat-dialog-content class="wrap-up-dialog" style="max-height: 80vh;">
  <div *ngIf="!wrapUpOption">
    <div *ngIf='data.checkEndCall' class="wrapUpEndCallContainer">
      <h3>Are you sure you want to end this call?</h3>
      <div class="wrapUpEndCallBtnList">
        <button mat-button color="primary" mat-dialog-close class="wrapUpBtn">Cancel</button>
        <button data-cy="end-call-confirmation" mat-flat-button (click)="endCallConfirmation()" class="wrapUpBtn confirmEndCall">Confirm</button>
      </div>
    </div>
    <div data-cy="end-call-disposition" *ngIf='!data.checkEndCall'>
      <h4>What happened?</h4>
      <h5>{{ endedCall ? endedCall.businessName : '' }}</h5>
      <mat-form-field
        (click)="$event.stopPropagation()">
        <mat-label>Select Outcome</mat-label>
        <mat-select data-cy="call-outcome-select" panelClass="wrapUpSelect" [(value)]="callDisposition" (selectionChange)="handleCallDisposition()">
          <mat-option *ngFor="let disposition of callDispositionOptions" [value]="disposition.value">{{ disposition.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="callDisposition && callDisposition === 'Made contact.'" class="wrapUpNextSteps">
      <h4>How would you tag this call?</h4>
      <mat-form-field
        (click)="$event.stopPropagation()">
        <mat-label>Tag this Call</mat-label>
        <mat-select data-cy="tag-call-select" panelClass="wrapUpSelect">
          <mat-option *ngFor="let tag of callTagOptions" [value]="tag.value" (click)="handleCallTag(tag.value)">{{ tag.value }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div data-cy="whats-next" *ngIf="wrapUpNextStepsDisplay()" class="wrapUpNextSteps">
      <h4 *ngIf="data.activeCall && data.activeCall.borrowerId">What's next?</h4>
      <button
        *ngIf="unknownCallerDisplay(true)"
        mat-stroked-button
        color="secondary"
        class="wrapUpBtn"
        (click)="wrapUpOption = 'moveToExisting'">
        <div class="wrapUp-BtnText">
          <p>Update Business</p>
          <span class="fa fa-check wrapUp-check" [ngClass]="businessUpdated ? 'green-check' : 'pre-check'"></span>
        </div>
      </button>
      <button
        *ngIf="unknownCallerDisplay(false)"
        mat-stroked-button
        color="secondary"
        class="wrapUpBtn"
        (click)="wrapUpOption = 'newLead'">
        <div class="wrapUp-BtnText">
          <p>New Business</p>
          <span class="fa fa-check wrapUp-check" [ngClass]="businessAdded ? 'green-check' : 'pre-check'"></span>
        </div>
      </button>
      <button
        *ngIf="nextStepBtnDisplay(false)"
        mat-stroked-button
        color="secondary"
        class="wrapUpBtn"
        data-cy="schedule-reminder"
        (click)="wrapUpOption = 'reminder'">
          <div class="wrapUp-BtnText">
            <p>Schedule Reminder</p>
            <span class="fa fa-check wrapUp-check" [ngClass]="reminderSet ? 'green-check' : 'pre-check'"></span>
          </div>
      </button>
      <button
        *ngIf="nextStepBtnDisplay(false)"
        mat-stroked-button
        color="secondary"
        class="wrapUpBtn"
        data-cy="add-note"
        (click)="wrapUpOption = 'notes'">
          <div class="wrapUp-BtnText">
            <p>Add Note</p>
            <span class="fa fa-check wrapUp-check" [ngClass]="noteLeft ? 'green-check' : 'pre-check'"></span>
          </div>
      </button>
      <button
        *ngIf="nextStepBtnDisplay(true)"
        mat-stroked-button
        color="secondary"
        class="wrapUpBtn"
        data-cy="send-text"
        (click)="wrapUpOption = 'sms'">
          <div class="wrapUp-BtnText">
            <p>Send Text</p>
            <span class="fa fa-check wrapUp-check" [ngClass]="smsSent ? 'green-check' : 'pre-check'"></span>
          </div>
      </button>
      <button
        *ngIf="nextStepBtnDisplay(true)"
        mat-stroked-button
        color="secondary"
        class="wrapUpBtn"
        data-cy="send-email"
        (click)="wrapUpOption = 'email'">
          <div class="wrapUp-BtnText">
            <p>Send Email</p>
            <span class="fa fa-check wrapUp-check" [ngClass]="emailSent ? 'green-check' : 'pre-check'"></span>
          </div>
      </button>
    </div>
    <div class="wrapUpNextSteps tw-mt-1">
      <button mat-flat-button
              [color]="'primary'"
              [disabled]="noteRequired && !noteLeft"
              matTooltip="{{noteRequired && !noteLeft ? 'Must add a Note' : '' }}"
              data-cy="save-and-close"
              (click)="updateCallCloseDialog()"
              *ngIf="displaySaveWrapUp()">
        {{ data.borrowersInQueue ? 'Next Business' : 'Save and Close' }}
      </button>
    </div>
  </div>

  <!-- CLOSE MODAL BUTTON -->
  <div class="close-modal">
    <span *ngIf="wrapUpOption && allowCloseWrapUpOption" (click)="closeWrapUpOption()" class="fa fa-times close-modal-btn"></span>
  </div>

  <div [ngSwitch]="wrapUpOption">
    <!-- ADD NEW LEAD -->
    <div class="new-lead" *ngSwitchCase="'newLead'">
      <app-add-new-lead-form [callWrapUp]="true" (callWrapUpSubmitted)="closeWrapUpOption()"></app-add-new-lead-form>
    </div>

    <!-- SEND EMAIL -->
    <div class="email ls1" *ngSwitchCase="'email'">
      <app-alert *ngIf="(alert$ | async) as alert"
        [level]="alert.level"
        [message]="alert.message"
        (dismissed)="handleAlertDismissed()"
      ></app-alert>
      <app-messages-create
        [borrower]="data.activeCall.borrower"
        [user]="data.activeCall.borrower && data.activeCall.borrower.borrower_owner ? data.activeCall.borrower.borrower_owner.lender_user.fullName : []"
        (emailCreate)="handleEmailCreate($event)"
      ></app-messages-create>
    </div>

    <!-- ADD TO EXISTING BUSINESS -->
    <div class="move-to-existing ls1" *ngSwitchCase="'moveToExisting'">
      <app-move-to-existing-business (callUpdated)="closeWrapUpOption()"></app-move-to-existing-business>
    </div>

    <!-- NOTE -->
    <div class="notes" *ngSwitchCase="'notes'">
      <app-notes-smart
        *ngIf="!!data.activeCall.borrower"
        [borrowerId]="data.activeCall.borrower.id"
        [addNoteOpen]="true"
        [expanded]="true"
        (noteAdded)="closeWrapUpOption()"
      ></app-notes-smart>
    </div>

    <!-- REMINDER -->
    <div class="reminder" *ngSwitchCase="'reminder'">
      <app-schedule-reminder-smart
        [view]="'borrower'"
        [borrowerId]="data.activeCall.borrower.id"
        (closeMenu)="closeWrapUpOption()">
      </app-schedule-reminder-smart>
    </div>

    <!-- SMS -->
    <div class="sms" *ngSwitchCase="'sms'">
      <app-sms-smart [borrower]="data.activeCall.borrower"></app-sms-smart>
    </div>
  </div>

</mat-dialog-content>

